import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { EIsinZeme } from 'enums/validations/isinValidationEnums';

/* funkce pro kontrolu kódu ISIN - souvisí s validací ISIN */
const _computeLuhnCheckDigit = (digits: number[]) => {
    // seznam cislic bez kontrolky
    let sum = 0;

    for (let i = 0; i < digits.length; i++) {
        let digit = digits[digits.length - i - 1]; // get digits in reverse order
        digit *= ((i + 1) % 2) + 1; // every 2nd number multiply with 2

        if (digit > 9) {
            digit = digit - 9;
        }

        sum += digit;
    }

    return (10 - (sum % 10)) % 10;
};

const validateISIN = (inputIsin: string, SKisin?: boolean) => {
    // 0 - OK
    // 1 - E: nezadano
    // 2 - E: chybna syntaxe
    // 3 - E: chybna kontrolka
    // 4 - E: chybna hodnota

    if (!inputIsin) return 1; // nezadano

    const ISINpattern = SKisin ? /^SK[0-9A-Z]{9}[0-9]$/ : /^(([A-Z]{2}|77)[0-9A-Z]{9}[0-9]{1})$/;
    const patternCheck = ISINpattern.test(inputIsin);

    if (!patternCheck) return 2; // chybna syntaxe

    if (!(inputIsin.substring(0, 2) in EIsinZeme || inputIsin.substring(0, 2) == EIsinZeme.seventySeven)) return 4; // chybna hodnota
    // transformace znaku
    const digits = [];

    for (let i = 0; i < inputIsin.length - 1; i++) {
        const chr = inputIsin.charAt(i);
        let digit;

        if (chr >= 'A' && chr <= 'Z') {
            digit = chr.charCodeAt(0) - 'A'.charCodeAt(0) + 10; // ASCII kód pro 'A' je 65
        } else {
            digit = chr.charCodeAt(0) - '0'.charCodeAt(0); // ASCII kód pro '0' je 48
        }

        if (digit > 9) {
            digits.push(Math.floor(digit / 10));
        }

        digits.push(digit % 10);
    }
    // kontrolni cislice (Luhn Algorithm)
    const compKontrolka = _computeLuhnCheckDigit(digits);

    if (compKontrolka !== inputIsin.charAt(inputIsin.length - 1).charCodeAt(0) - '0'.charCodeAt(0)) return 3; // chybna kontrolka

    return 0;
};

export const isinValidation = (SKisin?: boolean) => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || validateISIN(value, SKisin) === 0) return Promise.resolve();
            return Promise.reject(
                <TranslateText>
                    {SKisin && (value.length >= 2 ? value.slice(0, 2) !== 'SK' : false)
                        ? 'ISIN_SK_VALIDATION_ERR'
                        : 'NEVALIDNI_ISIN'}
                </TranslateText>
            );
        }
    })
];

export default isinValidation;
